module.exports = require("postcss/package.json");